import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/guard/auth.guard';
import { HomeComponent } from './home/home.component';

const routes: Routes = [
  {
    title: 'AYB - Home',
    path: '',
    canActivate: [AuthGuard],
    component: HomeComponent,
    pathMatch: 'full',
  },
  {
    title: 'AYB - Home',
    path: 'home',
    canActivate: [AuthGuard],
    component: HomeComponent,
  },
  {
    path: 'callback',
    loadComponent: () =>
      import('./auth/callback/callback.component').then(
        (m) => m.CallbackComponent,
      ),
  },
  {
    title: 'AYB - Asignación de Menú',
    path: 'asignacion-menu',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./asignacion-menu/asignacion-menu-routing.module').then(
        (m) => m.AsignacionMenuRoutingModule,
      ),
  },
  {
    title: 'AYB - Cocina',
    path: 'cocina',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./cocina/cocina-routing.module').then(
        (m) => m.CocinaRoutingModule,
      ),
  },
  {
    title: 'AYB - Almacén',
    path: 'gestion',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./almacen-insumos/almacen-insumos-routing.module').then(
        (m) => m.AlmacenInsumosRoutingModule,
      ),
  },
  {
    title: 'AYB - Menajería',
    path: 'almacen-menajeria',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./almacen-menajeria/almacen-menajeria-routing.module').then(
        (m) => m.AlmacenMenajeriaRoutingModule,
      ),
  },
  {
    title: 'AYB - Proveedores',
    path: 'proveedores',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./proveedores/proveedores-routing.module').then(
        (m) => m.ProveedoresRoutingModule,
      ),
  },
  {
    title: 'AYB - Reportes',
    path: 'reportes',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./reportes/reportes-routing.module').then(
        (m) => m.ReportesRoutingModule,
      ),
  },
  {
    title: 'AYB - Cuadro Picnic',
    path: 'cuadro-picnic',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./cuadro-picnic/cuadro-picnic-routing.module').then(
        (m) => m.CuadroPicnicRoutingModule,
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
